module.exports = __webpack_public_path__ + "img/persona-con-auto-y-telefono.4a8b7744.svg";